import { i18nProvider } from "../providers/commons/i18nProvider";
import type { ContactType } from "../types";

// English DB codes. Status stays Dutch in the DB (Warm/Actief/Slapend);
// type is a stable code so Jules can change the Dutch labels without a migration.
export const CONTACT_TYPES = [
  "person",
  "company",
  "partner",
] as const satisfies readonly ContactType[];

// Create and type pickers. `partner` stays a stored value for existing rows.
export const CONTACT_TYPE_CHOICES = [
  "person",
  "company",
] as const satisfies readonly ContactType[];

export type CreatableContactType = (typeof CONTACT_TYPE_CHOICES)[number];

export const CONTACT_TYPE_LABEL_KEYS: Record<ContactType, string> = {
  person: "palmtree.types.person",
  company: "palmtree.types.company",
  partner: "palmtree.types.partner",
};

export const CONTACT_TYPE_LISTS: {
  type: CreatableContactType;
  labelKey: string;
  path: string;
  emptyKey: string;
  searchKey: string;
}[] = [
  {
    type: "person",
    labelKey: "palmtree.lists.person.label",
    path: "/contactpersonen",
    emptyKey: "palmtree.lists.person.empty",
    searchKey: "palmtree.lists.person.search",
  },
  {
    type: "company",
    labelKey: "palmtree.lists.company.label",
    path: "/bedrijven",
    emptyKey: "palmtree.lists.company.empty",
    searchKey: "palmtree.lists.company.search",
  },
];

export const contactCardPath = (id: string | number) => `/contacten/${id}`;

export const contactEditPath = (id: string | number) =>
  `/contacten/${id}/bewerken`;

export const isContactType = (value: unknown): value is ContactType =>
  typeof value === "string" &&
  (CONTACT_TYPES as readonly string[]).includes(value);

export const isCreatableContactType = (
  value: unknown,
): value is CreatableContactType =>
  typeof value === "string" &&
  (CONTACT_TYPE_CHOICES as readonly string[]).includes(value);

export const contactTypeLabel = (type?: string | null) =>
  isContactType(type)
    ? i18nProvider.translate(CONTACT_TYPE_LABEL_KEYS[type])
    : "";

/** Unknown paths (including the dashboard test harness) fall back to people. */
export const contactListFromPath = (pathname: string) =>
  CONTACT_TYPE_LISTS.find((list) => list.path === pathname) ??
  CONTACT_TYPE_LISTS[0];

export const CONTACT_STATUSES = ["Warm", "Actief", "Slapend"] as const;
export type ContactStatus = (typeof CONTACT_STATUSES)[number];

export const PREFERRED_CHANNELS = [
  "Telefoon",
  "Email",
  "WhatsApp",
  "Anders",
] as const;
export type PreferredChannel = (typeof PREFERRED_CHANNELS)[number];

export const AANDACHT_LIMIT = 8;
export const VANDAAG_PREVIEW_LIMIT = 3;
